// extracted by mini-css-extract-plugin
export default {"iframeContainer":"VideoLesson_iframeContainer__SynlU","scormContainer":"VideoLesson_scormContainer__vSg3J","videoContainer":"VideoLesson_videoContainer__yJUUm"};